const PATH = '/calendars';

export default {
    async getCalendar(query) {

        return axios.get(`${PATH}`, {params: query});
    },
}
